module.exports = __webpack_public_path__ + "images/brooklyn-e00297e9bb29b062dd7b464a570e6786.jpg";